import { translateField } from '@/features/application/services/applicationDetailService'
import { shouldAutoTranslateFieldContent } from '@/lib/utils/googleTranslate'

/** Angular `translateContent` on blur — POST /api/translate when UI language is not English. */
export async function translateFieldOnBlur(
  field: string,
  value: string,
): Promise<string | null> {
  const text = String(value ?? '').trim()
  if (!text || !shouldAutoTranslateFieldContent()) return null

  const translated = await translateField(field, text)
  if (!translated || translated === text) return null
  return translated
}
